var config = {
    api: {
        domain: "https://api.zachhuxford.io"
    },
    disqus: {
        domain: "https://blog.zachhuxford.io"
    }
}

module.exports = config;